/*
 * Copyright (c) 2021 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightTextTools_AreaTextHighlight.js
 *
 * Description:	The class containing the functionality required by the Greenlight for text tools for an area text highlight.
 * 
 */

// The text tools object.
var g_oTextTools_AreaTextHighlight = {

	
};

(function () {
	"use strict";

	/**
	 * Load the text highlight tool for the page.
	 */
	function TextTools_AreaTextHighlight() {

		// Bounds.
		this.g_oBounds = {
			x1: 0,
			x2: 0,
			y1: 0,
			y2: 0
		};
	};

	/**
	 * Initialises a text highlight.
	 */
	TextTools_AreaTextHighlight.prototype.initialiseHighlight = function () {

		// Determine the canvas to highlight on, and the non highlight canvas.
		var oViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oArtworkViewer : g_oCompare.g_oCompareViewer;
		var oAnnotationViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oAnnotationViewer : g_oCompare.g_oCompareAnnotationViewer;
		var szHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer";
		var szNonHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "CompareAnnotationViewer" : "AnnotationViewer";

		// Reset the highlighting to the existing sections.
		g_oTextTools.removeHighlights(oAnnotationViewer);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oViewer, oAnnotationViewer);

		// Activate the mouse move event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointermove.annotationUI', function (event) {
			g_oTextTools_AreaTextHighlight.mouseMove(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointerdown', function (event) {
			g_oTextTools_AreaTextHighlight.mouseDown(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event for the compare canvas.
		$("#" + szNonHighlightCanvas).css("cursor", "default");
		changeCanvasFunction($("#" + szNonHighlightCanvas), 'pointerdown', function (event) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szHighlightUnavailableCanvas);
		});
	};

	/**
	 * Mouse move event for a text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.mouseMove = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Determine the canvas id.
		var szCanvasId = "#" + (!g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer");

		// Change the cursor to a crosshair.
		$(szCanvasId).css("cursor", "crosshair");

		// Highlight the existing section.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Mouse down event for a text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.mouseDown = function (event, oArtworkCanvas, oAnnotationCanvas) {
		
		// Get the position of the mouse.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);

		// Update the start and end bounds.
		g_oTextTools_AreaTextHighlight.g_oBounds.x1 = oPosition.x;
		g_oTextTools_AreaTextHighlight.g_oBounds.x2 = oPosition.x;
		g_oTextTools_AreaTextHighlight.g_oBounds.y1 = oPosition.y;
		g_oTextTools_AreaTextHighlight.g_oBounds.y2 = oPosition.y;

		// Reset the highlighting, then highlight the existing sections, then highlight the area.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
		g_oTextTools.highlightElement(g_oTextTools_AreaTextHighlight.g_oBounds.x1, g_oTextTools_AreaTextHighlight.g_oBounds.x2, g_oTextTools_AreaTextHighlight.g_oBounds.y1, g_oTextTools_AreaTextHighlight.g_oBounds.y2, oArtworkCanvas, oAnnotationCanvas);

		// Clear all bindings.
		changeCanvasFunction();

		// Determine the canvas id.
		var szCanvasId = "#" + (!g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer");

		// Change the cursor to crosshair.
		$(szCanvasId).css("cursor", "crosshair");

		// Set the mouse drag event.
		changeCanvasFunction($(szCanvasId), 'pointermove.annotationUI', function (event) {
			g_oTextTools_AreaTextHighlight.mouseDrag(event, oArtworkCanvas, oAnnotationCanvas);
		});

		// Set the mouse up event.
		changeCanvasFunction($(szCanvasId), 'pointerup', function (event) {
			g_oTextTools_AreaTextHighlight.mouseUp(event, oArtworkCanvas, oAnnotationCanvas);
		});
	};

	/**
	 * Mouse drag event for a text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.mouseDrag = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Get the position of the mouse.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);

		// Update the start and end bounds.
		g_oTextTools_AreaTextHighlight.g_oBounds.x2 = oPosition.x;
		g_oTextTools_AreaTextHighlight.g_oBounds.y2 = oPosition.y;

		// Reset the highlighting, then highlight the existing sections, then highlight the area.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
		g_oTextTools.highlightElement(g_oTextTools_AreaTextHighlight.g_oBounds.x1, g_oTextTools_AreaTextHighlight.g_oBounds.x2, g_oTextTools_AreaTextHighlight.g_oBounds.y1, g_oTextTools_AreaTextHighlight.g_oBounds.y2, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Mouse up event for a text highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.mouseUp = function (event, oArtworkCanvas, oAnnotationCanvas) {
		
		// Get the text in the area bounds.
		var oAreaSelection = g_oTextTools_AreaTextHighlight.getTextInAreaBounds(g_oTextTools_AreaTextHighlight.g_oBounds, oArtworkCanvas, oAnnotationCanvas);

		// Ensure we have highlighted something.
		if (oAreaSelection.length == 0) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szNoLiveTextFound);
			g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.AreaTextHighlight, g_oTextTools.g_eActiveAnnotationType, g_oTextTools.g_bHighlightIsCharacterAccuracy, g_oTextTools.g_bHighlightOnCompareCanvas, g_oTextTools.g_szHighlightColour);
			return;
		}

		// Add the words to the annotation text.
		g_oTextTools.g_oAnnotationText = g_oTextTools.g_oAnnotationText.concat(oAreaSelection);

		// If this is not a new annotation, re-initialise the highlight.
		if (g_oTextTools.g_iExistingAnnotationId != null) {
			g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.AreaTextHighlight, g_oTextTools.g_eActiveAnnotationType, g_oTextTools.g_bHighlightIsCharacterAccuracy, g_oTextTools.g_bHighlightOnCompareCanvas, g_oTextTools.g_szHighlightColour);
			return;
		}

		// End the highlight.
		g_oTextTools.endhighlight(oArtworkCanvas, oAnnotationCanvas, true);
	};

	/**
	 * Gets the text within an area bounds.
	 * @param {object} oBounds - The bounds.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.getTextInAreaBounds = function (oBounds, oArtworkCanvas, oAnnotationCanvas) {
		return g_oTextTools.g_bHighlightIsCharacterAccuracy ? g_oTextTools_AreaTextHighlight.getCharactersInAreaBounds(oBounds, oArtworkCanvas, oAnnotationCanvas) : g_oTextTools_AreaTextHighlight.getWordsInAreaBounds(oBounds, oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Gets words within bounds.
	 * @param {object} oBounds - The bounds.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.getWordsInAreaBounds = function (oBounds, oArtworkCanvas, oAnnotationCanvas) {

		// Outline the word list to be returned.
		var oWords = [];

		// Ensure the bounds are the correct direction.
		var oNormalisedBounds = {
			x1: Math.min(oBounds.x1, oBounds.x2),
			x2: Math.max(oBounds.x1, oBounds.x2),
			y1: Math.min(oBounds.y1, oBounds.y2),
			y2: Math.max(oBounds.y1, oBounds.y2)
		};

		// Get the text data for the document page.
		var oTextData = g_oTextData.getTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage).textData;

		// Loop through each of the words.
		for (var i = 0; i < oTextData.Paragraphs.length; i++) {
			for (var j = 0; j < oTextData.Paragraphs[i].Lines.length; j++) {
				for (var k = 0; k < oTextData.Paragraphs[i].Lines[j].Words.length; k++) {

					// If the word is in bounds.
					if (g_oTextTools_AreaTextHighlight.textInBounds(oNormalisedBounds, oTextData.Paragraphs[i].Lines[j].Words[k])) {

						// Add the word to the list.
						oWords.push({
							startingText: {
								paragraph: i,
								line: j,
								word: k
							},
							endingText: {
								paragraph: i,
								line: j,
								word: k
							},
							leftToRight: g_oTextTools.isTextHighlightLeftToRight()
						});
					}
				}
			}
		}

		// Return the result.
		return oWords;
	};

	/**
	 * Gets characters within bounds.
	 * @param {object} oBounds - The bounds.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_AreaTextHighlight.prototype.getCharactersInAreaBounds = function (oBounds, oArtworkCanvas, oAnnotationCanvas) {

		// Outline the character list to be returned.
		var oCharacters = [];

		// Ensure the bounds are the correct direction.
		var oNormalisedBounds = {
			x1: Math.min(oBounds.x1, oBounds.x2),
			x2: Math.max(oBounds.x1, oBounds.x2),
			y1: Math.min(oBounds.y1, oBounds.y2),
			y2: Math.max(oBounds.y1, oBounds.y2)
		};

		// Get the text data for the document page.
		var oTextData = g_oTextData.getTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage).textData;

		// Loop through each of the characters.
		for (var i = 0; i < oTextData.Paragraphs.length; i++) {
			for (var j = 0; j < oTextData.Paragraphs[i].Lines.length; j++) {
				for (var k = 0; k < oTextData.Paragraphs[i].Lines[j].Words.length; k++) {
					for (var l = 0; l < oTextData.Paragraphs[i].Lines[j].Words[k].Characters.length; l++) {

						// If the character is in bounds.
						if (g_oTextTools_AreaTextHighlight.textInBounds(oNormalisedBounds, oTextData.Paragraphs[i].Lines[j].Words[k].Characters[l])) {

							// Add the character to the list.
							oCharacters.push({
								startingText: {
									paragraph: i,
									line: j,
									word: k,
									character: l
								},
								endingText: {
									paragraph: i,
									line: j,
									word: k,
									character: l
								},
								leftToRight: g_oTextTools.isTextHighlightLeftToRight()
							});
						}
					}
				}
			}
		}

		// Return the result.
		return oCharacters;
	};

	/**
	 * Checks if a text item is in bounds.
	 * @param {object} oBounds - The bounds.
	 * @param {object} oText - The text.
	 */
	TextTools_AreaTextHighlight.prototype.textInBounds = function (oBounds, oText) {

		// Check for both a horizontal and vertical overlap.
		return !(oBounds.x1 >= oText.X2 || oText.X1 >= oBounds.x2) && !(oBounds.y1 >= oText.Y2 || oText.Y1 >= oBounds.y2);
	};

	// Add the Text Tools tool object to the window.
	window.TextTools_AreaTextHighlight = TextTools_AreaTextHighlight;
}());